import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "../src/css/common.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { size: "small" });

import axios from "./service/http.js"; // 引入你刚刚创建的 axios 实例
Vue.prototype.$axios = axios; // 将 Axios 挂载到 Vue 原型上

import Router from "vue-router";

// 获取原始的 push 和 replace 方法
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

// 定义一个变量来标识是否正在导航
let isNavigating = false;

// 重写 push 方法，防止短时间内重复导航
Router.prototype.push = function push(location) {
  if (isNavigating) return;
  isNavigating = true;
  return originalPush
    .call(this, location)
    .catch((err) => {
      if (err.name !== "NavigationDuplicated") {
        console.error("Navigation error:", err);
        throw err;
      }
    })
    .finally(() => {
      isNavigating = false;
    });
};

// 重写 replace 方法，防止短时间内重复导航
Router.prototype.replace = function replace(location) {
  if (isNavigating) return;
  isNavigating = true;
  return originalReplace
    .call(this, location)
    .catch((err) => {
      if (err.name !== "NavigationDuplicated") {
        console.error("Navigation error:", err);
        throw err;
      }
    })
    .finally(() => {
      isNavigating = false;
    });
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
